import { getString } from "../../common/common";

export const TAB4_HEADING1 = "TAB4_HEADING1";
export const TAB4_HEADING2 = "TAB4_HEADING2";
export const TAB4_HEADING3 = "TAB4_HEADING3";
export const TAB4_HEADING4 = "TAB4_HEADING4";

export const TAB4_LI1 = "TAB4_LI1";
export const TAB4_LI2 = "TAB4_LI2";
export const TAB4_LI3 = "TAB4_LI3";
export const TAB4_LI4 = "TAB4_LI4";
export const TAB4_LI5 = "TAB4_LI5";

export const translations = {
  en: {
    [TAB4_HEADING1]: "Airavat Superia",
    [TAB4_HEADING2]: "Chemical Toilet Facility",
    [TAB4_HEADING3]: "Multi-axle buses with special amenities",
    [TAB4_HEADING4]: "The salient features of Airavat Superia are as follows:",

    [TAB4_LI1]: "Dashboard controls for all cubicle actions.",
    [TAB4_LI2]: "Vacant, occupied & disabled status with display light.",
    [TAB4_LI3]:
      "Auto flush if the passenger has left the toilet without flushing.",
    [TAB4_LI4]: "Hand wash system with '10 seconds' water saving operation.",
    [TAB4_LI5]: "Easy to operate system to help clean out waste.",
  },
  kn: {
    [TAB4_HEADING1]: "ಐರಾವತ್ ಸುಪೇರಿಯಾ",
    [TAB4_HEADING2]: "ಕೆಮಿಕಲ್ ಟಾಯ್ಲೆಟ್  ಸೌಲಭ್ಯ",
    [TAB4_HEADING3]: "ವಿಶೇಷ ಸೌಕರ್ಯಗಳೊಂದಿಗೆ ಮಲ್ಟಿ-ಆಕ್ಸಲ್ ಬಸ್ಸುಗಳು",
    [TAB4_HEADING4]: "ಐರಾವತ್ ಸುಪೇರಿಯಾದ ಪ್ರಮುಖ ಲಕ್ಷಣಗಳು ಈ ಕೆಳಗಿನಂತಿವೆ:",

    [TAB4_LI1]: "ಎಲ್ಲಾ ಕ್ಯುಬಿಕಲ್ ಕ್ರಿಯೆಗಳಿಗೆ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್ ನಿಯಂತ್ರಣಗಳು.",
    [TAB4_LI2]: "ಡಿಸ್ಪ್ಲೇ ಲೈಟ್‌ನೊಂದಿಗೆ ಖಾಲಿ, ಆಕ್ರಮಿತ ಮತ್ತು ನಿಷ್ಕ್ರಿಯ ಸ್ಥಿತಿ.",
    [TAB4_LI3]:
      "ಪ್ರಯಾಣಿಕರು ಫ್ಲಶ್ ಮಾಡದೆ ಶೌಚಾಲಯದಿಂದ ಹೊರಬಂದಿದ್ದರೆ ಆಟೋ ಫ್ಲಶ್ ಆಗುತ್ತದೆ.",
    [TAB4_LI4]:
      "10 ಸೆಕೆಂಡ್‌ಗಳ' ನೀರಿನ ಉಳಿತಾಯ ಕಾರ್ಯಾಚರಣೆಯೊಂದಿಗೆ ಕೈ ತೊಳೆಯುವ ವ್ಯವಸ್ಥೆ.",
    [TAB4_LI5]:
      "ತ್ಯಾಜ್ಯವನ್ನು ಸ್ವಚ್ಛಗೊಳಿಸಲು ಸಹಾಯ ಮಾಡಲು ಸುಲಭವಾದ ಆಪರೇಟಿಂಗ್ ಸಿಸ್ಟಮ್.",
  },
};

export const t = (key = "") => {
  return getString(key, translations);
};
